import React, { Component } from 'react';
import { Field, reduxForm } from 'redux-form';
import { Grid, Form } from 'semantic-ui-react';
import moment from 'moment';

import SelectSitesTable from 'Common/SelectSitesTableReduxForm';
import { ELIGIBILITY_BY_APPLICATION_REPORT_FORM_NAME } from 'Common/FormEnum';
import { DatePickerField, ToggleField } from 'Common/SemanticWrapper';
import { EligibilityByApplicationReportEnum as Fields } from 'Common/FieldEnum';
import { ReduxFormButtonGroup } from 'Components/forms/ReduxFormButtonGroup';
import { TitledCard } from 'Components';
import { ProvisionTypeOptions } from 'Common/Constants/ProvisionTypeOptions';

class EligibilityByApplicationForm extends Component {
  maxAsOfDate = moment();

  render() {
    const { isFetching, dispatch } = this.props;

    return (
      <Form>
        <TitledCard title={'Report Parameters'}>
          <Grid>
            <Grid.Row>
              <Grid.Column>
                <Field
                  name={Fields.AsOfDate}
                  label={'As Of Date'}
                  maxDate={this.maxAsOfDate}
                  component={DatePickerField}
                  disabled={isFetching}
                />
              </Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column className="input-group--btn-group">
                <ReduxFormButtonGroup
                  label={'Provision Type'}
                  dispatch={dispatch}
                  formName={ELIGIBILITY_BY_APPLICATION_REPORT_FORM_NAME}
                  fieldName={Fields.ProvisionType}
                  disabled={isFetching}
                  options={ProvisionTypeOptions}
                />
              </Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column>
                <Field
                  name={Fields.IncludeApplicationSummary}
                  label={'Include Application Summary'}
                  component={ToggleField}
                  disabled={isFetching}
                />
              </Grid.Column>
            </Grid.Row>
          </Grid>
        </TitledCard>
        <TitledCard title={'Select Sites'}>
          <Field name={Fields.Sites} component={SelectSitesTable} />
        </TitledCard>
      </Form>
    );
  }
}

const validate = values => {
  const errors = {};
  if (!values[Fields.AsOfDate]) {
    errors[Fields.AsOfDate] = 'Required';
  }

  if (
    !values[Fields.Sites] ||
    (Array.isArray(values[Fields.Sites]) && !values[Fields.Sites].length)
  ) {
    errors[Fields.Sites] = 'At least one site must be selected.';
  }

  if (!moment(values[Fields.AsOfDate]).isBefore()) {
    errors[Fields.AsOfDate] = 'The date must be in the past';
  }

  return errors;
};

export default reduxForm({
  validate,
  form: ELIGIBILITY_BY_APPLICATION_REPORT_FORM_NAME,
  enableReinitialize: true,
})(EligibilityByApplicationForm);



// WEBPACK FOOTER //
// ./src/pages/eligibilityByApplicationReport/components/EligibilityByApplicationForm.js